import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Col,
    Dropdown,
    FormCheck,
    Modal,
    Overlay,
    Row,
    Tab,
    Table,
    Tabs,
    Tooltip,
} from "react-bootstrap";
import goldplan from "../../assets/images/goldplan.svg";
import WorkFlowPassModal from "../WorkFlowPassModal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { GetByPrimarykey } from "../../services/ReduxTookit/Slice/UserRedux";
import SubmitLoading from "../../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../../component/common-component/Loaders/MainpageLoader";
import { SubscriptionGetList, UpdatePlan, CalculateSubscriptionPrice } from "../../services/ReduxTookit/Slice/SubscriptionsRedux";
import { SubscriberValidateDeActivate } from "../../services/ReduxTookit/Slice/SubscribersRedux";
import { commonservices } from "../../services/CommonServices";
import PaymentMethodSelection from "../PaymentMethodSelection";

const MemberShipSubscription = () => {
    let ProfileInfo = useSelector(
        (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
    );
    const PlanDetails = useSelector((state) => state?.sunscriptionRedux?.SubscriptionGetListData?.data?.data?.data);
    const [contactRef, setContactRef] = useState(null);
    const dispatch = useDispatch();
    const [showContact, setShowContact] = useState(false);

    const [isWorkFlowChecked_oldval, setIsWorkFlowChecked_oldval] = useState(false);
    const [isDeveloperChecked_oldval, setIsDeveloperChecked_oldval] = useState(false);

    const [isWorkFlowChecked, setIsWorkFlowChecked] = useState(false);
    const [isDeveloperChecked, setIsDeveloperChecked] = useState(false);

    const [IsChangeInUserType, setIsChangeInUserType] = useState(false);
    const [IsChangeInSubscription, setIsChangeInSubscription] = useState(false);

    const [workflowPassModalShow, setWorkflowPassModalShow] = useState(false);
    const [ActiveSubscriptionID, setActiveSubscriptionID] = useState(0);
    const [ActiveSubscriptionExpiryTimeRemains, setActiveSubscriptionExpiryTimeRemains] = useState({
        expDate: "",
        isRenue: false
    });
    const [ActiveSubscriptionMonth, setActiveSubscriptionMonth] = useState("monthly");

    const [NewSubscriptionMonth, setNewSubscriptionMonth] = useState("monthly");
    const [NewSubscriptionID, setNewSubscriptionID] = useState(0);
    const [YearlyDiscount, setYearlyDiscount] = useState(0);
    const [Loading, setLoading] = useState(false);

    const [PaymentPopup, setPaymentPopup] = useState({
        show: false,
        item: null,
        itemtype: "Subscription",
    });

    const GetPlanList = () => {
        setLoading(true);
        dispatch(SubscriptionGetList())?.then((res) => {
            setLoading(false);
        });
    };

    const handleshowContactPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");

            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowContact(!showContact);
    };

    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };

    useEffect(() => {
        setIsWorkFlowChecked(ProfileInfo?.isclient);
        setIsDeveloperChecked(ProfileInfo?.isdeveloper);

        setIsWorkFlowChecked_oldval(ProfileInfo?.isclient);
        setIsDeveloperChecked_oldval(ProfileInfo?.isdeveloper);
    }, [ProfileInfo]);

    useEffect(() => {
        GetPlanList();
    }, []);

    useEffect(() => {
        const storedInvoiceData = sessionStorage.getItem("reopen_bill_payment_invoice");
        if (storedInvoiceData) {
            try {
                const parsed = JSON.parse(storedInvoiceData);
                const item = parsed?.item || parsed;
                const itemtype = parsed?.itemtype || "Subscription";
                if (item && (itemtype.toLowerCase().includes("subscription") || item.subscriptionid)) {
                    setPaymentPopup({
                        show: true,
                        item: item,
                        itemtype: itemtype,
                    });
                    sessionStorage.removeItem("reopen_bill_payment_invoice");
                }
            } catch (e) {
                console.error("Failed to parse reopen_bill_payment_invoice", e);
            }
        }
    }, []);

    useEffect(() => {
        if (PlanDetails) {
            if (PlanDetails?.dataList4?.[0]?.subscriptionid) {
                const expiryDateStr = PlanDetails?.dataList4?.[0]?.expirydate;
                if (expiryDateStr) {
                    const expiryDate = new Date(expiryDateStr);
                    const currentDate = new Date();
                    // Calculate date difference in days
                    const diffTime = expiryDate.getTime() - currentDate.getTime();
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    const isRenew = diffDays <= 2 && diffDays >= 0;
                    setActiveSubscriptionExpiryTimeRemains({
                        expDate: commonservices?.getDateInFormat(expiryDate),
                        isRenue: isRenew,
                    });
                } else {
                    // Handle case when expiry date is missing
                    setActiveSubscriptionExpiryTimeRemains({
                        expDate: "",
                        isRenue: false,
                    });
                }
                setActiveSubscriptionID(PlanDetails?.dataList4?.[0]?.subscriptionid);
                if (PlanDetails?.dataList4?.[0]?.noofmonth) {
                    if (parseInt(PlanDetails?.dataList4?.[0]?.noofmonth) === 12) {
                        setActiveSubscriptionMonth("yearly");
                        setNewSubscriptionMonth("yearly")
                    }
                }
            }
            if (PlanDetails?.dataList3 && PlanDetails?.dataList3.length > 0) {
                setYearlyDiscount(parseInt(PlanDetails?.dataList3[0].value));
            }
        }
    }, [PlanDetails]);

    const handleOutsideClick = (event) => {
        if (!contactRef.contains(event.target)) {
            handleshowContactPopup(event); // Close the overlay
        }
    };
    useEffect(() => {
        if (showContact) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [showContact]);

    const handleItemClick = (action, isRenew = false) => {
        if (IsChangeInUserType) {
            if (ProfileInfo?.isorganization) {
                setLoading(false);
                setWorkflowPassModalShow(true);
            } else {
                fnProcessPlanUpdate([], isRenew);
            }
        } else {
            fnProcessPlanUpdate([], isRenew);
        }
    };

    const fnProcessPlanUpdate = (selectedContact, isRenew = false) => {
        const isSubscriptionChanging = IsChangeInSubscription || isRenew;
        if (isSubscriptionChanging) {
            setLoading(true);
            let pricePayload = {
                oldnoofmonth: ActiveSubscriptionMonth === "monthly" ? 1 : 12,
                oldsubscriptionid: ActiveSubscriptionID,
                newsubscriptionid: isRenew ? ActiveSubscriptionID : (NewSubscriptionID || ActiveSubscriptionID),
                newnoofmonth: NewSubscriptionMonth === "monthly" ? 1 : 12,
                ischangeinsubscription: true,
            };
            dispatch(CalculateSubscriptionPrice(pricePayload))?.then((response) => {
                setLoading(false);
                if (response?.payload?.isValidate && response?.payload?.data?.status_code === 1) {
                    const calculatedPrice = response.payload.data.data;
                    if (calculatedPrice !== null && calculatedPrice !== undefined && Number(calculatedPrice) > 0) {
                        setPaymentPopup({
                            show: true,
                            item: {
                                invoicefinalamount: calculatedPrice,
                                invoicenetamount: calculatedPrice,
                                invoiceno: "Auto Generate",
                                dateofinvoice: new Date().toISOString(),
                                duedate: "N/A",
                                invoiceduedate: "N/A",
                                subscriptionid: isRenew ? ActiveSubscriptionID : (NewSubscriptionID || ActiveSubscriptionID),
                                newsubscriptionid: isRenew ? ActiveSubscriptionID : (NewSubscriptionID || ActiveSubscriptionID),
                                oldsubscriptionid: ActiveSubscriptionID,
                                newnoofmonth: NewSubscriptionMonth === "monthly" ? 1 : 12,
                                oldnoofmonth: ActiveSubscriptionMonth === "monthly" ? 1 : 12,
                                ischangeinusertype: IsChangeInUserType,
                                ischangeinsubscription: true,
                                isworkflowchecked: isWorkFlowChecked,
                                isdeveloperchecked: isDeveloperChecked,
                                contactlist: selectedContact || [],
                                ischangeinworkflowmanagement: isWorkFlowChecked_oldval !== isWorkFlowChecked,
                                ischangeindeveloper: isDeveloperChecked_oldval !== isDeveloperChecked,
                            },
                            itemtype: "Subscription",
                        });
                    } else {
                        // 0 price or free plan
                        fnSubmitToApi(selectedContact, isRenew);
                    }
                } else {
                    toast.error(response?.payload?.data?.message || "Failed to calculate subscription price.");
                }
            });
        } else if (IsChangeInUserType) {
            fnSubmitToApi(selectedContact, isRenew);
        }
    };

    const fnSubmitToApi = (selectedContact, isRenew = false) => {
        const isSubscriptionChanging = IsChangeInSubscription || isRenew;
        if (IsChangeInUserType || isSubscriptionChanging) {
            setLoading(true);
            let payload = {
                oldnoofmonth: ActiveSubscriptionMonth === "monthly" ? 1 : 12,
                oldsubscriptionid: ActiveSubscriptionID,
                newsubscriptionid: isRenew ? ActiveSubscriptionID : (NewSubscriptionID || ActiveSubscriptionID),
                newnoofmonth: NewSubscriptionMonth === "monthly" ? 1 : 12,
                returnurl: window.location.origin + "/management-listing?from=subscription&session_id={CHECKOUT_SESSION_ID}",
                ischangeinusertype: IsChangeInUserType,
                ischangeinsubscription: isSubscriptionChanging,
                isworkflowchecked: isWorkFlowChecked,
                isdeveloperchecked: isDeveloperChecked,
                contactlist: selectedContact,
                ischangeinworkflowmanagement: isWorkFlowChecked_oldval !== isWorkFlowChecked,
                ischangeindeveloper: isDeveloperChecked_oldval !== isDeveloperChecked
            };
            dispatch(UpdatePlan(payload))?.then((response) => {
                if (response?.payload?.isValidate) {
                    if (response?.payload?.data?.status_code === 1) {
                        if (response?.payload?.data?.message === "Transaction is generated") {
                            window.location = response.payload.data.data;
                        } else {
                            toast.success(response?.payload?.data?.message);
                            dispatch(GetByPrimarykey({}));
                            GetPlanList();
                        }
                    } else {
                        toast.error(response?.payload?.data?.message);
                    }
                }
                setLoading(false);
            });
        }
    };

    const SelectNewPlan = (id) => {
        setNewSubscriptionID(id);
    };

    const CalPriceAfterYearlyDiscount = (price) => {
        let yearlyprice = price * 12;
        let discount = (yearlyprice * YearlyDiscount) / 100;
        return yearlyprice - discount;
    }
    const [IsDisplayValidationMessage, setIsDisplayValidationMessage] = useState(false);
    const [DisplayValidationMessageData, setDisplayValidationMessageData] = useState({ checkfor: "", message: "" });


    const _SubscriberValidateDeActivate = async (event, CheckFor) => {
        if (!event.target.checked) {
            setLoading(true);
            await dispatch(SubscriberValidateDeActivate(CheckFor))?.then((response) => {
                if (response?.payload?.data?.status_code === 0) {
                    setIsDisplayValidationMessage(true);
                    if (CheckFor === "DATAFACTORY") {
                        let message = "";
                        if (response?.payload?.data?.data?.workflow && response?.payload?.data?.data?.workflow.length > 0) {
                            message = message + "You have " + response?.payload?.data?.data?.workflow.length + " workflow in your account.<br/>"
                        }

                        if (response?.payload?.data?.data?.invoice && response?.payload?.data?.data?.invoice.length > 0) {
                            message = message + "You have " + response?.payload?.data?.data?.invoice.length + " invoice are pendding.<br/>"
                        }
                        setDisplayValidationMessageData({ checkfor: "Workflow Management", message: message })

                    }
                    else if (CheckFor === "DEVELOPER") {
                        let message = "";
                        if (response?.payload?.data?.data?.machine && response?.payload?.data?.data?.machine.length > 0) {
                            message = message + "You have " + response?.payload?.data?.data?.machine.length + " machine in your account.<br/>"
                        }

                        if (response?.payload?.data?.data?.wallet && response?.payload?.data?.data?.wallet.length > 0) {
                            message = message + "You have total $" + response?.payload?.data?.data?.wallet[0].amount + " amount in your wallet.<br/>"
                        }
                        setDisplayValidationMessageData({ checkfor: "Developer", message: message })
                    }
                }
                else if (response?.payload?.data?.status_code === 1) {
                    if (CheckFor === "DATAFACTORY") {
                        setIsChangeInUserType(true);
                        setIsWorkFlowChecked(!isWorkFlowChecked);
                    }
                    else if (CheckFor === "DEVELOPER") {
                        setIsChangeInUserType(true);
                        setIsDeveloperChecked(!isDeveloperChecked);
                    }
                }
            });
            setLoading(false);
        }
        else {
            if (CheckFor === "DATAFACTORY") {
                setIsChangeInUserType(true);
                setIsWorkFlowChecked(!isWorkFlowChecked);
            }
            else if (CheckFor === "DEVELOPER") {
                setIsChangeInUserType(true);
                setIsDeveloperChecked(!isDeveloperChecked);
            }
        }
    };

    const [IsViewPlan, setIsViewPlan] = useState(false);
    const [IsViewPlanData, setIsViewPlanData] = useState({ name: {}, data: [] });
    function fuViewPlan(e, subscription, data) {

        e.stopPropagation();
        if (subscription && data) {
            if (data.length > 0) {
                setIsViewPlanData({ subscription: subscription, data: data })
                setIsViewPlan(true);
            }
        }
    }

    return (
        <>
            {Loading && <MainpageLoader />}
            <div className="membarship-package-list">
                <Row>
                    <Col xl={6}>
                        <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto membership-head">
                            <div className="payment-method-title">
                                <h2 className="mb-2">
                                    Enable Workflow Management
                                </h2>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p>
                                    Activate workflow management capabilities to design, monitor, and govern workflow execution across the organization while leveraging existing machine assets.
                                </p>
                                <div>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={isWorkFlowChecked}
                                            onChange={(e) => _SubscriberValidateDeActivate(e, "DATAFACTORY")}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xl={6}>
                        <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto membership-head">
                            <div className="payment-method-title">
                                <h2 className="mb-2">Enable Machine Development</h2>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p>
                                    Activate machine development capabilities to create, test, publish, and maintain machines with access to advanced development and deployment tools.
                                </p>

                                <div>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={isDeveloperChecked}
                                            onChange={(e) => _SubscriberValidateDeActivate(e, "DEVELOPER")}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="profile-common">
                    <div className="membership-tab-box">
                        <div>
                            <div className="membarship-inner-title">
                                <h2>Select your Magic Plan</h2>
                                <p>
                                    Choose the perfect Magick Plan that suits your needs. Whether
                                    you're looking for basic features or advanced tools, we have
                                    options tailored just for you
                                </p>
                            </div>
                            <div className="membarship-inner-tabs">

                                <Tabs
                                    activeKey={NewSubscriptionMonth}
                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                    onSelect={(key) => {
                                        setNewSubscriptionMonth(key);
                                        setIsChangeInSubscription(false);
                                        SelectNewPlan(0);
                                    }}
                                >
                                    <Tab

                                        key={0}
                                        eventKey={"monthly"}
                                        title={
                                            <span className="membershiptab d-flex align-items-center gap-2">
                                                <h2 style={{ width: "70px" }}>Monthly</h2>
                                            </span>
                                        }
                                    >
                                        <div className="yearlydata d-flex gap-5 mt-6">

                                        </div>
                                    </Tab>
                                    <Tab

                                        key={1}
                                        eventKey={"yearly"}
                                        title={
                                            <span className="membershiptab d-flex align-items-center gap-2">
                                                <h2 style={{ width: "70px" }}>Yearly</h2>
                                                {YearlyDiscount > 0 && <p>-{YearlyDiscount}%</p>}
                                            </span>
                                        }
                                    >
                                        <div className="yearlydata d-flex gap-5 mt-6">

                                        </div>
                                    </Tab>
                                </Tabs>
                                <div className="yearlydata-detail">
                                    <ul>
                                        <li>
                                            Gain access to advanced workflow automation and machine
                                            development tools
                                        </li>
                                        <li>
                                            Unlock exclusive features to create, manage, and optimize
                                            custom data workflows
                                        </li>
                                        <li>
                                            Enhance productivity with seamless integration of
                                            analytics and automation services
                                        </li>
                                        <li>
                                            Enhance productivity with seamless integration of
                                            analytics and automation services
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="primiumdatablock">
                            {
                                NewSubscriptionMonth &&
                                <>{PlanDetails?.dataList1?.map((item, index) => (
                                    <div className={`all-datapackage-active-common ${ActiveSubscriptionID !== item.subscriptionid && "make-disabled"}`} onClick={(e) => {
                                        if (parseFloat(item.price) > 0) {
                                            setIsChangeInSubscription(true);
                                            SelectNewPlan(item.subscriptionid);
                                        }
                                        else {
                                            toast.error("The Free Plan is not available for your account.");
                                        }
                                    }}>
                                        <div className={`yearlydata-package mb-3 ${ActiveSubscriptionID === item.subscriptionid && ActiveSubscriptionMonth === NewSubscriptionMonth ? "yearlydata-package-active" : NewSubscriptionID === item.subscriptionid ? "yearlydata-package-selected" : ""} `}>
                                            {
                                                ActiveSubscriptionID === item.subscriptionid && ActiveSubscriptionMonth === NewSubscriptionMonth ?
                                                    <p className="yearlydata-package-active-state activeplan">
                                                        Active Plan {ActiveSubscriptionExpiryTimeRemains?.expDate && <span className="text-danger">{`(Expire's on ${ActiveSubscriptionExpiryTimeRemains?.expDate})`}</span>}
                                                    </p>
                                                    :
                                                    <>
                                                        {
                                                            NewSubscriptionID === item.subscriptionid ?
                                                                <p className="yearlydata-package-active-state selectedplan">
                                                                    Selected Plan
                                                                </p>
                                                                :
                                                                <p className="yearlydata-package-active-state upgradeplan">
                                                                    Upgrade Plan
                                                                </p>
                                                        }
                                                    </>
                                            }


                                            <div className="d-flex w-100 justify-content-between">
                                                <div className="plandata-payment-detail">
                                                    <div className="d-flex align-items-start gap-2">
                                                        <div>
                                                            <img src={goldplan} alt="goldplan" />
                                                        </div>

                                                        <div className="detatitle-payment">
                                                            <h4>{item.subscriptionname}</h4>
                                                            <p>
                                                                {
                                                                    item.details &&
                                                                    <>
                                                                        {
                                                                            item.details.length > 150 ? <>{item.details.substr(0, 149)}...</> : <>{item.details}</>
                                                                        }
                                                                    </>
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="plandata-payment-status">
                                                    {
                                                        parseFloat(item.price) > 0 ?
                                                            <>
                                                                {
                                                                    NewSubscriptionMonth === "monthly" ?
                                                                        <>
                                                                            <h2>${item.price} <span> / Monthly </span></h2><p className="mb-10px"><b>OR</b></p><p className="mb-10px">${CalPriceAfterYearlyDiscount(item.price)} / Yearly</p><p className="cursor-pointer text-primary" onClick={(e) => fuViewPlan(e, item, PlanDetails?.dataList2?.filter(
                                                                                (d) =>
                                                                                    d?.subscriptionid ===
                                                                                    item?.subscriptionid
                                                                            ))}>View Details</p>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <h2>${CalPriceAfterYearlyDiscount(item.price)} <span> / Yearly </span></h2><p className="mb-10px"><b>OR</b></p><p className="mb-10px">${item.price} / Monthly</p><p className="cursor-pointer text-primary" onClick={(e) => fuViewPlan(e, item, PlanDetails?.dataList2?.filter(
                                                                                (d) =>
                                                                                    d?.subscriptionid ===
                                                                                    item?.subscriptionid
                                                                            ))}>View Details</p>
                                                                        </>
                                                                }
                                                            </>
                                                            :
                                                            <></>
                                                    }

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}</>
                            }
                        </div>
                    </div>

                    <div className="popup-footer d-flex justify-content-end monthandyeardata">
                        {
                            ActiveSubscriptionExpiryTimeRemains?.isRenue &&
                            <button
                                className={"blue-btn width200"}
                                onClick={(e) => {
                                    setIsChangeInSubscription(true);
                                    setNewSubscriptionID(ActiveSubscriptionID);
                                    handleItemClick(null, true);
                                }}
                            >
                                {Loading ? <SubmitLoading /> : "Renew"}
                            </button>
                        }
                        <button
                            disabled={(IsChangeInUserType || IsChangeInSubscription) ? false : true}
                            className={
                                (IsChangeInUserType || IsChangeInSubscription) ? "blue-btn width200" : "disable-blue-btn width200"
                            }
                            onClick={(e) => {
                                handleItemClick();
                            }}
                        >
                            {Loading ? <SubmitLoading /> : "Upgrade Plan"}
                        </button>
                    </div>
                </div>
            </div>

            {workflowPassModalShow && (
                <WorkFlowPassModal
                    show={workflowPassModalShow}
                    onHide={(e) => setWorkflowPassModalShow(false)}
                    callBackFunction={(e) => { setWorkflowPassModalShow(false); fnProcessPlanUpdate(e); }}
                />
            )}

            {PaymentPopup && PaymentPopup.show && PaymentPopup.item && (
                <PaymentMethodSelection
                    show={PaymentPopup.show}
                    item={PaymentPopup.item}
                    itemtype={PaymentPopup.itemtype || "Subscription"}
                    returnpath="/management-listing"
                    onPaymentSuccess={() => {
                        dispatch(GetByPrimarykey({}));
                        GetPlanList();
                        setPaymentPopup({
                            show: false,
                            item: null,
                            itemtype: "Subscription",
                        });
                    }}
                    onHide={() => {
                        setPaymentPopup({
                            show: false,
                            item: null,
                            itemtype: "Subscription",
                        });
                    }}
                />
            )}

            {IsDisplayValidationMessage && (
                <Modal
                    show={IsDisplayValidationMessage}
                    onHide={(e) =>
                        setIsDisplayValidationMessage(false)
                    }
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="delete-modal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <div className="text-center">
                            <h6 className="text-danger">
                                Your are not able to deactive your {DisplayValidationMessageData.checkfor} account
                            </h6>
                            <p className="text-danger mt-3" dangerouslySetInnerHTML={{ __html: DisplayValidationMessageData.message }}>

                            </p>
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-danger"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsDisplayValidationMessage(false)
                                    }}
                                >
                                    OK
                                </button>
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>
            )}

            {
                IsViewPlan &&
                <Modal
                    id="plandetails"
                    show={IsViewPlan}
                    onHide={(e) => setIsViewPlan(false)}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="pass-contactmodel"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Plan : {IsViewPlanData.subscription.subscriptionname}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="w-100 mb-3">{IsViewPlanData.subscription.details}</p>
                        <div className="table-wrapper-main">
                            <Table responsive>
                                <tbody>
                                    {IsViewPlanData.data?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item?.featurename}</td>
                                            <td>{item?.featurevaluedisplayname}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="grey-btn w-auto" onClick={(e) => setIsViewPlan(false)}>
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
};

export default MemberShipSubscription;
